import type { ReactNode } from "react";
import Alert from "@mui/material/Alert";
import { ConnectedElementsProvider } from "@bw/shared/components";
import type { StripeFrontendConfigResponse } from "@bw/shared/types/generated";

/** Player-native unavailable state around the shared connected-account provider. */
export function MaterialConnectedElementsProvider({
  config,
  children,
}: {
  config: StripeFrontendConfigResponse;
  children: ReactNode;
}) {
  return (
    <ConnectedElementsProvider
      config={config}
      unavailableFallback={
        <Alert severity="error" role="alert">
          This facility can&apos;t take card payments yet.
        </Alert>
      }
    >
      {children}
    </ConnectedElementsProvider>
  );
}
